enum PAGE_TITLES {
  ATTRIBUTES = 'Attributes',
  REPORTS = 'Reports',
  REPORTING_HIERARCHY = 'Reporting Hierarchy',
  COURSE_CATALOG = 'Course Catalog',
  ACADEMIC_UNITS = 'Academic Unit Types',
  SURVEYS = 'Surveys',
  MY_SURVEYS = 'Survey Templates',
  SURVEY_TEMPLATE = 'Survey Template',
  USERS = 'People',
  TERMS = 'Terms',
  EMAIL = 'Email Delivery History',
  SIS_SYNC_LOGS = 'SIS Sync Logs',
  SIS_SYNC_RUN = 'SIS Sync Run',
  ACCOUNTS = 'Accounts',
  LOGIN = 'Login',
  LOADING = 'Loading...',
  NOT_FOUND = '404 Not Found',
  SURVEY_COMPLETED = 'Survey Completed',
  SURVEY_CLOSED = 'Survey Closed',
  SETTINGS = 'Settings',
  FACULTY_AND_STAFF = 'Faculty and Staff',
  STUDENTS = 'Students',
  STUDENT_SURVEYS = 'Student Surveys',
  INSTRUCTOR_DASHBOARD = 'Instructor Dashboard',
  REPORTING = 'Reporting',
  DISTRIBUTION_SERIES = 'Survey Projects',
  COURSE_ENROLLMENT = 'Course Evaluation',
  NO_PERMISSIONS = 'No permissions',
  UNTITLED_SURVEY_TEMPLATE = 'Untitled Survey Template',
  SURVEY_DISTRIBUTION = 'Survey Project',
  TASKS = 'Activity Monitor',
  EMAIL_SETTINGS = 'Email Settings Page',
  PEOPLE = 'People',
  QRCODE = 'QR Code',
  ADMIN = 'Admin',
  ADMIN_ADDED_QUESTION = 'Academic Added Questions',
  INSTRUCTOR_ADDED_QUESTION = 'Instructor Added Questions',
  SURVEY_COMPLETED_PUBLIC = 'Survey Completed Public',
  PERMISSION_MANAGEMENT = 'Permission And Role Management',
  INSTITUTION_SETTINGS = 'Institution Settings'
}

export default PAGE_TITLES
